// `id` is a.k.a `entryId`
export function createContentStoreKey(id, locale) {
  return locale ? `${id}::${locale}` : id
}

// Convert a value to boolean, handling string representations of boolean values
export function toBooleanValue(value) {
  // If already a boolean, return as-is
  if (typeof value === 'boolean') {
    return value
  }

  // If string, check if lowercase equals 'true'
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true'
  }

  // For other types, use JavaScript's truthiness evaluation
  return Boolean(value)
}
